function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "add-document-icon");

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M6.26,20.26a.66.66,0,0,1-.67.66H3.36A2.67,2.67,0,0,1,.69,18.26V6.53A2.68,2.68,0,0,1,3.36,3.86h8.19a2.68,2.68,0,0,1,2.67,2.67v4.1a.67.67,0,0,1-1.33,0V6.53a1.34,1.34,0,0,0-1.34-1.34H3.36A1.33,1.33,0,0,0,2,6.53V18.26a1.33,1.33,0,0,0,1.33,1.33H5.59A.67.67,0,0,1,6.26,20.26Zm4.63-12.4H4a.66.66,0,0,0-.66.67A.65.65,0,0,0,4,9.19h6.87a.65.65,0,0,0,.66-.66A.66.66,0,0,0,10.89,7.86Zm.66,3.33a.65.65,0,0,0-.66-.66H4a.65.65,0,0,0-.66.66.66.66,0,0,0,.66.67h6.87A.66.66,0,0,0,11.55,11.19ZM4,13.19a.67.67,0,0,0,0,1.34H8.19a.67.67,0,0,0,0-1.34ZM15.4,16.34,11.75,20a.68.68,0,0,1-.29.18l-2.69.74a.55.55,0,0,1-.18,0,.67.67,0,0,1-.48-.2A.66.66,0,0,1,8,20.06l.8-2.62a.78.78,0,0,1,.16-.28l3.66-3.65a2,2,0,0,1,2.83,2.83Zm-2,.13-1-.95L10,18l-.39,1.3,1.35-.37Zm1.07-2a.66.66,0,0,0-.94,0l-.13.13.94.95.13-.13A.68.68,0,0,0,14.46,14.45Z",
  fill: "currentColor"
}), React.createElement("line", {
  id: "ac1cb6c4-5b56-460e-8324-3082f63b92e3",
  "data-name": "<Trazado>",
  x1: 18.99,
  y1: 2.64,
  x2: 18.99,
  y2: 9.51,
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), React.createElement("line", {
  x1: 15.55,
  y1: 6.08,
  x2: 22.42,
  y2: 6.08,
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 22.83 22.83"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/add-document-icon.3c948707.svg";
export { SvgComponent as ReactComponent };